import SidebarCallout from '@/components/_blog-updates/SidebarCallout';
import { CraftSidebarCalloutProps } from './CraftSidebarCallout.types';
import { mapBlockToSidebarCalloutProps } from './CraftSidebarCallout.utils';

const CraftSidebarCallout = ({ block }: CraftSidebarCalloutProps) => {
  const props = mapBlockToSidebarCalloutProps(block);

  return <SidebarCallout {...props} />;
};

export default CraftSidebarCallout;
